import { render, staticRenderFns } from "./templateconf.vue?vue&type=template&id=e64a8f56&"
import script from "./templateconf.vue?vue&type=script&lang=js&"
export * from "./templateconf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports